<cw-full-screen-loader></cw-full-screen-loader>

<div class="twc-main-container">
    <div class="twc-content-container" *ngIf="showContent">
        <div class="twc-content" [hidden]="appSharedService.loading && !appSharedService.keepBackgroundVisible">
            <div class="twc-content-area twc-p-0 twc-d-flex flex-direction-column">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>